import React from 'react';
import { Grid } from '@mui/material';
import { RiskGrade, RiskSetupLoFCoF, RiskSetupAssetFilter } from '@Components';
import { RiskConfig } from '@Types/risk.types';

export interface ClassicRiskSetupBodyProps {
	isLoading: boolean;
	isBusy: boolean;
	lofTableCells: string[][];
	cofTableCells: string[][];
	assetFilter: RiskConfig['assetFilter'];
}

// Pre-redesign Risk Setup body (flag off): LoF/CoF tables + asset filter on
// the left, RiskGrade on the right.
export const ClassicRiskSetupBody = ({
	isLoading,
	isBusy,
	lofTableCells,
	cofTableCells,
	assetFilter,
}: ClassicRiskSetupBodyProps) => (
	<>
		<Grid item xs={6}>
			<RiskSetupLoFCoF
				isLoading={isLoading}
				lofTableCells={lofTableCells}
				cofTableCells={cofTableCells}
			/>
			{assetFilter && <RiskSetupAssetFilter assetFilter={assetFilter} />}
		</Grid>
		<Grid item xs={6} className={isBusy ? 'wait' : ''}>
			<RiskGrade isLoading={isBusy} />
		</Grid>
	</>
);
